module.exports = __webpack_public_path__ + "img/vps_icon_fix.db7b105.png";